

var elem = document.querySelector('.main-carousel');
var flkty = new Flickity( elem, {
  // options
  cellAlign: 'center',
  contain: true,
  freeScroll: false,
  pageDots: false,
  setGallerySize: false,
  wrapAround: true,
  adaptiveHeight: true
});
